import { render, staticRenderFns } from "./fb-comments.vue?vue&type=template&id=44ff27f2&scoped=true&lang=pug&"
import script from "./fb-comments.vue?vue&type=script&lang=js&"
export * from "./fb-comments.vue?vue&type=script&lang=js&"
import style0 from "./fb-comments.vue?vue&type=style&index=0&id=44ff27f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff27f2",
  null
  
)

export default component.exports